namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmIszrRole extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmIszrRoleReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmIszrRoleObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmIszrRoleObj());
            this.detailObj.createBase({
                contentName: "detailAdmIszrRole",
                contentCaption: "jres:33000755",  //RC 33000755 : Agendová role ISZR
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmIszrRole", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmIszrRoleObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmIszrRoleReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["nazev"]
        }

        setSxsDetail(): string {
            return "{0}".format((this.data.agendova_role) ? this.data.agendova_role.toString() : "");
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmIszrRoleSaveDto, close: boolean) {
            if (this.options.newRecord == false && this.data.agenda != data.agenda) {
                this.cnt.dialogs.confirmDangerous("jres:33000759", "jres:33000760").on("yes", () => { //RC 33000760 : Opravdu si přejete změnit agendu role? Tuto akci doporučujeme dělat pouze v případě dřívějšího chybného zadání dat.
                    this.saveDataInternal(data, close);
                }) 
            } else
                this.saveDataInternal(data, close);
        }

        private saveDataInternal(data: Gordic.AdmIsl.Interface.GAdmIszrRoleSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            (this.cnt.isl.AdmIszrRole.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    })
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmIszrRole", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmIszrRole.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.nazev) ? this.data.nazev : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeSelectField("agenda", Gordic.Prefabs.Select.szrsage(), {
                model: "model.agenda=value.agenda",
                flag: this.createFlagNemenne(),
                serverFilters: {
                    aktivita: [100, 300, 500, 600, 900]
                }
                //tag: {
                //    text: "jres:33000758", //RC 33000758 : Změnu agendy pečlivě zvažte, role musí být vždy přiřazena pouze jedné agendě. 
                //    state: "warning"
                //}
            });
            this.MakeField("agendova_role", { flag: this.createFlagNemenne() });
            this.MakeField("nazev");
            this.MakeField("poznamka");
            this.MakeField("duvod_ucel");
            this.MakeField("seznam_udaju");
            this.MakeField("seznam_udaju_ros");
            this.MakeField("seznam_udaju_isc");
            this.MakeField("seznam_udaju_iseo");
            this.MakeField("sezn_udaju_aiseop");
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }
    }
}